export const NFT2023ID = 1122487441;
export const NFT2024ID = 1937292495;
export const NFT2025ID = 3061343167;
export const NFT2026ID = 3596435521;

// The 2026 birthday NFT was claimable only during June 12, 2026 (UTC); anything
// unclaimed is burned afterwards. Past this instant the drop/claim is over, so
// the 2026 pages stop showing the countdown/drop/wallet-connect UI and just
// point at the whitelist spreadsheet. (Compare against server-corrected time.)
export const DROP_2026_OVER_AT = Math.floor(
  Date.parse('2026-06-13T00:00:00Z') / 1000,
);

// Whitelist / eligibility spreadsheet for the 2026 birthday NFT.
export const WL_2026_SHEET =
  'https://docs.google.com/spreadsheets/d/1gGIK_k3ZPxbT_WVhmTyqZ8YYuOEP6dsEjCVXWt78-a0/edit?usp=sharing';